import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import useForm from 'react-hook-form'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { withRouter } from 'react-router-dom'
import ReactLoading from 'react-loading'
import { faHome, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Container
} from 'reactstrap'
import PropTypes from 'prop-types'
import { createModel } from 'redux/actions/models'
import { loadProjects } from 'redux/actions/projects'
import ModelForm from 'components/Models/form'
import BackButton from 'components/BackButton'

const NewModel = ({ createModel, history, loadProjects, loading, loadingModel, projects }) => {
  const [hasFetchedProjects, setHasFetchedProjects] = useState(false)
  const { register, handleSubmit, errors } = useForm()

  useEffect(() => {
    if (!hasFetchedProjects) {
      loadProjects()
    }
    setHasFetchedProjects(true)
  }, [loadProjects, projects, hasFetchedProjects, setHasFetchedProjects])

  return (
    <Container className="pt-2 pt-md-5 pt-lg-6" fluid>
      <BackButton />
      <Row>
        <Col className="order-xl-1" xl="12">
          <Card className="bg-secondary shadow">
            <CardHeader className="bg-white border-0">
              <Row className="align-items-center">
                <Col xs="12">
                  <h3 className="mb-0">
                    <FontAwesomeIcon icon={faHome} className="mr-1"/> Nuevo Modelo<br/>
                    <Button
                      tag={Link}
                      color="primary"
                      to="/admin/models"
                      size="sm"
                      className="mt-2"
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="mr-2"/>
                      Regresar a Lista
                    </Button>
                  </h3>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {loadingModel && (
                <ReactLoading type="spinningBubbles" color="#000" height={30} width={30} className="mt-3" />
              )}
              <ModelForm
                onSubmit={handleSubmit(form => createModel(form, history))}
                register={register}
                errors={errors}
                loading={loading}
                loadingModel={loadingModel}
                projects={projects}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

const mapStateToProps = ({ models: { loading: loadingModel }, projects: { projects, loading } }) => ({
  loading,
  loadingModel,
  projects
})

const mapDispatchToProps = dispatch => ({
  loadProjects: () => dispatch(loadProjects()),
  createModel: (values, history) => dispatch(createModel(values, history))
})

NewModel.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  })),
  loading: PropTypes.bool,
  loadingModel: PropTypes.bool,
  createModel: PropTypes.func.isRequired,
  loadProjects: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
}

NewModel.defaultProps = {
  loading: false,
  loadingModel: false,
  form: {
    description: '',
    name: '',
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewModel))
